import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const setPayPalDeviceData: CheckoutActionCreator = (deviceData) => (dispatch) => {
  dispatch({
    type: actionTypes.PAYMENT_SET_PAYPAL_DEVICE_DATA,
    deviceData,
  })
}
